export function configureHttp(http, {apiUrl, store, router, eventBus}) {
  http.options.root = apiUrl;

  const publicUrls = ["login", "ping", "refresh_token", "logout"];
  let refreshRequest = null;

  const getAuthData = (key) => {
    return localStorage.getItem(key) || sessionStorage.getItem(key);
  };

  function saveTokenPair(body, rememberToken = null) {
    if (!body || !body.access_token || !body.refresh_token) return false;

    let storage = sessionStorage;

    if (rememberToken === true || (rememberToken === null && localStorage.getItem('token'))) {
      storage = localStorage;
    }

    storage.setItem("token", body.access_token);
    storage.setItem("refresh_token", body.refresh_token);
    return true;
  }

  function logoutAndRedirect() {
    return store.dispatch("logout").then(() => {
      router.push('/login').catch(() => {});
    });
  }

  function updateRefreshToken() {
    const refreshToken = getAuthData("refresh_token");
    if (!refreshToken) {
      return Promise.reject(new Error("Refresh token is missing"));
    }

    if (!refreshRequest) {
      refreshRequest = http.post("refresh_token", {
        refresh_token: refreshToken
      }).then(response => {
        if (!saveTokenPair(response.body)) {
          throw new Error("Refresh response does not contain a token pair");
        }
        return response.body.access_token;
      }).finally(() => {
        refreshRequest = null;
      });
    }

    return refreshRequest;
  }

  http.interceptors.unshift((request, next) => {
    const url = request._originalUrl || request.url;
    request._originalUrl = url;
    if (!request._apiRootApplied) {
      request.url = apiUrl + url;
      request._apiRootApplied = true;
    }
    const isPublicUrl = publicUrls.includes(url);
    const token = getAuthData("token");
    if (token) {
      request.headers.set('Authorization', 'Bearer '+ token);
    } else if (!isPublicUrl) {
      router.push('/login').catch(() => {});
      return;
    }

    next((response) => {
      if (response.status === 404) {
        if (!request.ignore404) {
          eventBus.$emit('http-error-404');
        }
      }

      if (!isPublicUrl) {
        if (response.status === 401) {
          if (!request._retriedAfterRefresh && getAuthData("refresh_token")) {
            request._retriedAfterRefresh = true;
            return updateRefreshToken().then(accessToken => {
              request.headers.set('Authorization', 'Bearer ' + accessToken);
              return http(request);
            }, error => {
              // A network or server failure does not mean the session was revoked.
              if (error.status === 401 || error.status === 403) {
                logoutAndRedirect();
              }
              return Promise.reject(error);
            });
          }

          logoutAndRedirect();
        }

        if (response.status === 403) {
          eventBus.$emit('http-error-403');
        }
      }
    })
  });
}



// WEBPACK FOOTER //
// ./src/http.js